import { Route, Routes } from 'react-router-dom';

import ErrorBoundaryLocal from 'components/App/ErrorBoundary';

import HistoryMobile from '../HistoryMobile';
import MainViewMobile from '../MainViewMobile';
import StatusDetailsMobile from '../StatusDetailsMobile';

const StatusesRoutingMobile = () => (
  <Routes>
    <Route 
        element={<MainViewMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path=""
    />
    <Route 
        element={<MainViewMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path="/:type"
    />
    <Route
        element={<StatusDetailsMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path="/:type/:groupName"
    />
    <Route
        element={<HistoryMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path="/:type/:groupName/history"
    />
    <Route
        element={<StatusDetailsMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path="/:type/:groupName/:name"
    />
    <Route
        element={<HistoryMobile/>}
        ErrorBoundary={ErrorBoundaryLocal}
        path="/:type/:groupName/:name/history"
    />
  </Routes>
)

export default StatusesRoutingMobile;
